import { Grid, InputBase, Typography, alpha, styled } from "@mui/material"

export const MainContainer = styled(Grid)(
  ({}) => `
    width:100%;
    height: max-content;
    display:flex;
    justify-content:center;
`
)

export const Container = styled(Grid)(
  ({}) => `
    width:100%;
    display:flex;
    justify-content:center;
   
`
)

export const ButtonContainer = styled(Grid)(
  ({}) => `
  display: flex;
  align-items: center;
  justify-content: space-around;
   
`
)

export const FormContainer = styled(Grid)(
  ({ theme: { breakpoints } }) => `
      background-color:#fff;
      width:35%;
      height: max-content;
      padding:16px;
      border-radius:8px;
      box-shadow: 6px 8px 39px -7px rgba(0,0,0,0.50);
      -webkit-box-shadow: 6px 8px 39px -7px rgba(0,0,0,0.50);
      -moz-box-shadow: 6px 8px 39px -7px rgba(0,0,0,0.50);

      ${[breakpoints.down("md")]}{
        width:90%;
      }
  `
)

export const FullFormContainer = styled(Grid)(
  ({ theme: { breakpoints } }) => `
      background-color:#fff;
      width: 100%;
      height: max-content;
      padding:16px;
      margin: auto;
      border-radius:8px;
      box-shadow: 3px 3px 19px -7px rgba(0,0,0,0.50);
      -webkit-box-shadow: 3px 3px 19px -7px rgba(0,0,0,0.50);
      -moz-box-shadow: 3px 3px 19px -7px rgba(0,0,0,0.50);

      ${[breakpoints.down("md")]}{
        width:100%;
      }
  `
)


export const LabelContainer = styled(Grid)(
  ({ theme: { breakpoints } }) => `

  // background:red;

   & .title {
    width:74%;

    ${[breakpoints.down("md")]}{
      font-size:10px;
      width:40%;
    }
   }

   & .caption {
    font-size:8px;
   }

   & .container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
   }

   & .date{
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 6px;
    width: 100%;
   }

   & .pass{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 6px;
    width: 100%;
   }

   & .button{
    font-size:10px;
    min-width: 75px;
    padding: 9px 3px;
    max-height: 30px;
   }

   & .error{
    color:red;
    font-size: 10px;
   }

   & .error-container{
    width:100%;
      display:flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      gap: 3px;
   }


  

   display: flex;
   align-items: flex-start;
   justify-content: space-between;
   gap: 3px;
   flex-direction: column;
  `
)
export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    textAlign: "right",
    direction: "ltr",
    borderRadius: 6,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 14,
    width: "100%",
    padding: "4px 12px",
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main
    }
  }
}))

export const CustomInput = styled('input')(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
    textAlign: "right",
    direction: "initial",
    borderRadius: 6,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 14,
    width: "100%",
    padding: "6px 12px",
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main
    },
    outline:"unset"
}))

export const AmountText = styled(Typography)(
  ({}) => `
  display: inline-block;
  font-size:20px;
  margin-left:2px;
  font-weight: bolder;
`
)